import { c as _c } from "react/compiler-runtime";
import { Button } from '@sbt-web/ui';
type Props = {
  label: string;
  className?: string;
  onClick: () => void;
};
const InfoBadge = t0 => {
  const $ = _c(7);
  const {
    label,
    className,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <img src="/static/img/ui/info.svg" height={16} width={16} alt="" loading="lazy" decoding="async" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `Più dettagli sui valori del filtro "${label}"`;
  const t3 = className ?? "";
  let t4;
  if ($[1] !== t3) {
    t4 = [t3];
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== onClick || $[4] !== t2 || $[5] !== t4) {
    t5 = <Button design="text" size="small" onClick={onClick} icon={t1} aria-label={t2} classes={t4} />;
    $[3] = onClick;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export { InfoBadge };